$(document).ready(function () {
    $('.c-testimonial-container.carousel').carousel('pause');
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.isBackgrounSetted) {
        return;
    }

    window.isBackgrounSetted = true;

    const customerTestimonialElements = document.querySelectorAll('.c-testimonial-element');
    customerTestimonialElements.forEach(function (customerTestimonialElement) {
        maxHeightImage = getMaxCarouselImageHeight();
        setBackground(customerTestimonialElement, maxHeightImage);
    });
});

function getMaxCarouselImageHeight() {

    const customerTestimonialItems = document.querySelectorAll('.c-testimonial-element');
    let maxHeightImage = 0;
    customerTestimonialItems.forEach(function (customerTestimonialElement) {
        const imageId = 'customerTestimonialImage' + customerTestimonialElement.getAttribute('data-widget-id');
        const childImage = customerTestimonialElement.querySelector('#' + imageId);
        if (childImage) {
            const height = childImage.offsetHeight;
            if (height > maxHeightImage) {
                maxHeightImage = height;
            }
        }
    });
    return maxHeightImage;
}

function setBackground(element, maxHeightImage) {
    const imageId = 'customerTestimonialImage' + element.getAttribute('data-widget-id');
    const childImage = element.querySelector('img[id="' + imageId + '"]');

    element.style.background = getBackgroundStyle(childImage);
    element.style.backgroundSize = 'cover';
    element.style.height = maxHeightImage + 'px';
    element.style.minHeight = '350px';
    element.style.maxHeight = '450px';
}

function getBackgroundStyle(imageElement) {
    return `linear-gradient(to right, var(--gradient-color-1), var(--gradient-color-2), transparent) ${getBackgroundStyleImage(imageElement)}`;
}

function getBackgroundStyleImage(imageElement) {
    if (!imageElement) {
        return '';
    }

    const mobileSize = 992;
    return $(window).width() < mobileSize ? '' : `, url('${imageElement.src}') no-repeat center`;
}
